import { render, staticRenderFns } from "./LcpAsessment.vue?vue&type=template&id=37ad9c52&"
import script from "./LcpAsessment.vue?vue&type=script&lang=js&"
export * from "./LcpAsessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports